import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, Send, CheckCircle2, AlertCircle } from 'lucide-react';
import { useT } from '../components/site/i18n';
// ⬇️ Cole aqui a sua Access Key do Web3Forms (https://web3forms.com)
// Substitua o valor abaixo pela chave recebida por e-mail ao criar sua conta.
const WEB3FORMS_ACCESS_KEY = 'YOUR_WEB3FORMS_ACCESS_KEY';
const FadeIn = ({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) => <motion.div initial={{
  opacity: 0,
  y: 30
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-50px'
}} transition={{
  duration: 0.7,
  delay,
  ease: [0.21, 0.47, 0.32, 0.98]
}} className={className} data-id="element-443" data-mp="30tkv6l5o9p3b">
    {children}
  </motion.div>;
export function Contato() {
  const t = useT();
  const [formState, setFormState] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormState('submitting');
    const formData = new FormData(e.currentTarget);
    formData.append('access_key', WEB3FORMS_ACCESS_KEY);
    formData.append('from_name', 'BairrouApp - Site');
    formData.append('subject', 'Nova mensagem pelo site BairrouApp');
    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formData
      });
      const data = await response.json();
      if (data.success) {
        setFormState('success');
      } else {
        setFormState('error');
      }
    } catch {
      setFormState('error');
    }
  };
  return <div className="min-h-screen bg-brand-cream dark:bg-gray-900 pt-24 pb-24 relative overflow-hidden transition-colors duration-300" data-id="element-444" data-mp="ykdhs491bevk">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-[0.03] dark:opacity-[0.05] pointer-events-none" style={{
      backgroundImage: 'radial-gradient(currentColor 1px, transparent 1px)',
      backgroundSize: '24px 24px'
    }} data-id="element-445" data-mp="3jc5xjwcfie7r"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-446" data-mp="2vak7cqs7dc2w">
        <FadeIn className="text-center mb-20 pt-12" data-id="element-447" data-mp="2qfwp39nsldwr">
          <span className="text-brand-green-dark dark:text-brand-green-light font-bold tracking-wider uppercase text-sm mb-6 flex items-center justify-center gap-2" data-id="element-448" data-mp="2limp502s1juo">
            <Mail size={16} className="text-brand-yellow" data-id="element-449" data-mp="2gh777gvwbtgi" />
            {t.contato.heroEyebrow}
          </span>
          <h1 className="text-5xl md:text-7xl font-sans font-extrabold text-brand-charcoal dark:text-white mb-6 tracking-tight" data-id="element-450" data-mp="2bmjo5xjnvr9b">
            <span className="relative inline-block" data-id="element-451" data-mp="22k27dymrzqtp">
              <span className="relative z-10" data-id="element-452" data-mp="22llmhlwp3vtw">{t.contato.heroTitle}</span>
              {/* SVG Highlight */}
              <svg className="absolute -bottom-2 left-0 w-full h-4 text-brand-yellow -z-10" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-453" data-mp="5ow7n05dqqej">
                <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="4" fill="none" strokeLinecap="round" aria-hidden="true" data-id="element-454" data-mp="daroyu4ov6mc" />
              </svg>
            </span>
          </h1>
          <p className="text-xl text-brand-charcoal/70 dark:text-gray-300 max-w-2xl mx-auto leading-relaxed" data-id="element-455" data-mp="3ligj2uri3m1u">
            {t.contato.heroDesc}
          </p>
        </FadeIn>

        <div className="grid lg:grid-cols-5 gap-12 lg:gap-16" data-id="element-456" data-mp="3qj4jg71mdf8q">
          {/* Contact Info */}
          <div className="lg:col-span-2 space-y-8" data-id="element-457" data-mp="3vih5wqokwkas">
            <FadeIn delay={0.1} className="bg-white dark:bg-gray-800 p-10 rounded-3xl shadow-sm border-t-4 border-t-brand-yellow border-x border-b border-gray-100 dark:border-gray-700 h-full relative overflow-hidden group transition-colors duration-300" data-id="element-458" data-mp="3dn0gnndez2d">
              <div className="absolute top-0 right-0 w-24 h-24 bg-brand-yellow/10 dark:bg-brand-yellow/5 rounded-bl-full -z-10 group-hover:scale-150 transition-transform duration-500" data-id="element-459" data-mp="1d9s7vbnf7x5k"></div>
              <h3 className="font-bold text-xl text-brand-charcoal dark:text-white mb-8" data-id="element-460" data-mp="1n9aphlfuz6ug">
                {t.contato.infoTitle}
              </h3>

              <div className="space-y-8 relative" data-id="element-461" data-mp="1i8d99eeesmvl">
                <div className="flex items-start gap-5 relative z-10" data-id="element-462" data-mp="1w8nykd02lten">
                  <div className="w-12 h-12 bg-white dark:bg-gray-900 border-2 border-brand-green/20 dark:border-brand-green/10 text-brand-green-dark dark:text-brand-green-light rounded-2xl flex items-center justify-center shrink-0 shadow-sm" data-id="element-463" data-mp="1racmrwq7t8ts">
                    <Mail size={20} data-id="element-464" data-mp="211h2wzrmmzq7" />
                  </div>
                  <div data-id="element-465" data-mp="2eznslsmf9tes">
                    <p className="font-bold text-brand-charcoal dark:text-white mb-1" data-id="element-466" data-mp="2ez5l1zub7srk">
                      {t.contato.infoEmail}
                    </p>
                    <a href="mailto:jon@bairrou.online" className="text-brand-charcoal/60 dark:text-gray-400 hover:text-brand-green-dark dark:hover:text-brand-green-light transition-colors font-medium" data-id="element-467" data-mp="2awit7yxn27ud">
                      jon@bairrou.online
                    </a>
                  </div>
                </div>
              </div>
            </FadeIn>
          </div>

          {/* Contact Form */}
          <div className="lg:col-span-3" data-id="element-468" data-mp="2avcyuh25cam3">
            <FadeIn delay={0.2} className="bg-white dark:bg-gray-800 p-10 md:p-12 rounded-3xl shadow-md border border-gray-100 dark:border-gray-700 transition-colors duration-300" data-id="element-469" data-mp="2fmuwav4ynt2b">
              {formState === 'success' ? <div className="text-center py-16" data-id="element-470" data-mp="25xbdtql5u17z">
                  <div className="w-24 h-24 bg-brand-green/10 dark:bg-brand-green/20 text-brand-green-dark dark:text-brand-green-light rounded-full flex items-center justify-center mx-auto mb-8" data-id="element-471" data-mp="1rwqvswn2k9fj">
                    <CheckCircle2 size={48} data-id="element-472" data-mp="2gol4b4ucza6" />
                  </div>
                  <h3 className="text-3xl font-sans font-extrabold text-brand-charcoal dark:text-white mb-4 tracking-tight" data-id="element-473" data-mp="2hzpac27891t">
                    {t.contato.successTitle}
                  </h3>
                  <p className="text-brand-charcoal/60 dark:text-gray-300 mb-10 text-lg leading-relaxed max-w-sm mx-auto" data-id="element-474" data-mp="3pr4ro1s6hv96">
                    {t.contato.successDesc}
                  </p>
                  <button onClick={() => setFormState('idle')} className="bg-brand-green hover:bg-brand-green-dark text-white px-8 py-4 rounded-full font-bold transition-all shadow-sm hover:shadow-md" data-id="element-475" data-mp="le7uxgz4ilxn">
                    {t.contato.successButton}
                  </button>
                </div> : formState === 'error' ? <div className="text-center py-16" data-id="element-476" data-mp="2x5v3p018kow7">
                  <div className="w-24 h-24 bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 rounded-full flex items-center justify-center mx-auto mb-8" data-id="element-477" data-mp="2s57d2fgx6a2i">
                    <AlertCircle size={48} data-id="element-478" data-mp="2hzpdkt8cyy5d" />
                  </div>
                  <h3 className="text-3xl font-sans font-extrabold text-brand-charcoal dark:text-white mb-4 tracking-tight" data-id="element-479" data-mp="2n14tk6voiegw">
                    {t.contato.errorTitle}
                  </h3>
                  <p className="text-brand-charcoal/60 dark:text-gray-300 mb-10 text-lg leading-relaxed max-w-sm mx-auto" data-id="element-480" data-mp="2wr7wayslr6sf">
                    {t.contato.errorDesc}
                  </p>
                  <button onClick={() => setFormState('idle')} className="bg-brand-green hover:bg-brand-green-dark text-white px-8 py-4 rounded-full font-bold transition-all shadow-sm hover:shadow-md" data-id="element-481" data-mp="35q376o6ld522">
                    {t.contato.errorButton}
                  </button>
                </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-482" data-mp="1lareiytkse2e">
                  <div className="grid md:grid-cols-2 gap-6" data-id="element-483" data-mp="1ld45u2l840s4">
                    <div data-id="element-484" data-mp="3n7idekm1rjp4">
                      <label htmlFor="name" className="block text-sm font-bold text-brand-charcoal dark:text-gray-200 mb-2" data-id="element-485" data-mp="3n6qhf8ojfjyb">
                        {t.contato.formName}
                      </label>
                      <input type="text" id="name" name="name" required className="w-full px-5 py-4 rounded-2xl border border-gray-200 dark:border-gray-700 focus:border-brand-green dark:focus:border-brand-green-light focus:ring-2 focus:ring-brand-green/20 dark:focus:ring-brand-green-light/20 outline-none transition-all bg-gray-50/50 dark:bg-gray-900/50 hover:bg-gray-50 dark:hover:bg-gray-900 focus:bg-white dark:focus:bg-gray-900 text-brand-charcoal dark:text-white" placeholder={t.contato.formNamePlaceholder} data-id="element-486" data-mp="3s0uqbxhd6221" />
                    </div>
                    <div data-id="element-487" data-mp="w0r8waidzbp8">
                      <label htmlFor="email" className="block text-sm font-bold text-brand-charcoal dark:text-gray-200 mb-2" data-id="element-488" data-mp="w4our3wcmhct">
                        {t.contato.formEmail}
                      </label>
                      <input type="email" id="email" name="email" required className="w-full px-5 py-4 rounded-2xl border border-gray-200 dark:border-gray-700 focus:border-brand-green dark:focus:border-brand-green-light focus:ring-2 focus:ring-brand-green/20 dark:focus:ring-brand-green-light/20 outline-none transition-all bg-gray-50/50 dark:bg-gray-900/50 hover:bg-gray-50 dark:hover:bg-gray-900 focus:bg-white dark:focus:bg-gray-900 text-brand-charcoal dark:text-white" placeholder={t.contato.formEmailPlaceholder} data-id="element-489" data-mp="r3rb0mvoxf97" />
                    </div>
                  </div>

                  <div data-id="element-490" data-mp="s9hpyf5u55i7">
                    <label htmlFor="subject" className="block text-sm font-bold text-brand-charcoal dark:text-gray-200 mb-2" data-id="element-491" data-mp="s9zstun06hz3">
                      {t.contato.formSubject}
                    </label>
                    <select id="subject" name="topic" required className="w-full px-5 py-4 rounded-2xl border border-gray-200 dark:border-gray-700 focus:border-brand-green dark:focus:border-brand-green-light focus:ring-2 focus:ring-brand-green/20 dark:focus:ring-brand-green-light/20 outline-none transition-all bg-gray-50/50 dark:bg-gray-900/50 hover:bg-gray-50 dark:hover:bg-gray-900 focus:bg-white dark:focus:bg-gray-900 text-brand-charcoal dark:text-white appearance-none" data-id="element-492" data-mp="jamm39q9k7i2">
                      <option value="" data-id="element-493" data-mp="3mrml7l26t7to">
                        {t.contato.formSubjectPlaceholder}
                      </option>
                      <option value="voce" data-id="element-494" data-mp="2z2ep3guqte9h">{t.contato.formSub1}</option>
                      <option value="negocio" data-id="element-495" data-mp="2z47yv50nkelp">{t.contato.formSub2}</option>
                      <option value="marca" data-id="element-496" data-mp="3d3hcpy1dywmi">{t.contato.formSub3}</option>
                      <option value="imprensa" data-id="element-497" data-mp="382jszh0q9uiw">{t.contato.formSub4}</option>
                      <option value="investidor" data-id="element-498" data-mp="3m2ck3dg62cre">{t.contato.formSub6}</option>
                      <option value="ong" data-id="element-499" data-mp="3m0843x4ztnar">{t.contato.formSub7}</option>
                      <option value="outro" data-id="element-500" data-mp="3i0hhm5mi1tc1">{t.contato.formSub5}</option>
                    </select>
                  </div>

                  <div data-id="element-501" data-mp="3vu8hsnecc0v3">
                    <label htmlFor="message" className="block text-sm font-bold text-brand-charcoal dark:text-gray-200 mb-2" data-id="element-502" data-mp="3qtkuabpbm25m">
                      {t.contato.formMessage}
                    </label>
                    <textarea id="message" name="message" required rows={5} className="w-full px-5 py-4 rounded-2xl border border-gray-200 dark:border-gray-700 focus:border-brand-green dark:focus:border-brand-green-light focus:ring-2 focus:ring-brand-green/20 dark:focus:ring-brand-green-light/20 outline-none transition-all resize-none bg-gray-50/50 dark:bg-gray-900/50 hover:bg-gray-50 dark:hover:bg-gray-900 focus:bg-white dark:focus:bg-gray-900 text-brand-charcoal dark:text-white" placeholder={t.contato.formMessagePlaceholder} data-id="element-503" data-mp="4k01igpvisp5"></textarea>
                  </div>

                  {/* Honeypot anti-spam (oculto) */}
                  <input type="checkbox" name="botcheck" className="hidden" style={{
                display: 'none'
              }} tabIndex={-1} autoComplete="off" data-id="element-504" data-mp="19bqbx81v63ub" />

                  <button type="submit" disabled={formState === 'submitting'} className="w-full bg-brand-green hover:bg-brand-green-dark text-white font-bold py-4 rounded-full flex items-center justify-center gap-2 transition-all disabled:opacity-70 shadow-sm hover:shadow-md mt-4" data-id="element-505" data-mp="33mzxpmfoxkym">
                    {formState === 'submitting' ? <span className="animate-pulse" data-id="element-506" data-mp="3mhevj8q9n7kv">
                        {t.contato.formSubmitting}
                      </span> : <>
                        {t.contato.formSubmit} <Send size={18} data-id="element-507" data-mp="37mqvwb7jr3d6" />
                      </>}
                  </button>
                </form>}
            </FadeIn>
          </div>
        </div>
      </div>
    </div>;
}